import React from 'react';

import { DetailRowError } from '../detail-row/DetailRowError';

export const TaxImpactGainLossError: React.FC = () => {
  return <DetailRowError data-testid="gain-loss">Est. realized gains/losses</DetailRowError>;
};
